export default {
  newDesign: true,
  parameters: {
    landing_id: "BRLquizTC2",
    segment: 42,
    success_page: "success_long",
  },
  ageRules: {
    min: 5,
    max: 17,
  },
  title:
    "Cursos de programação para crianças de 8 a 17 anos em uma escola internacional | Kodland",
  downtimeUrl: "https://www.kodland.org/pt",
  startPage: {
    title:
      "Responda às perguntas para se inscrever na sua primeira aula experimental",
    subtitle:
      "Mostraremos como transformar a paixão por gadgets em uma vantagem:<br>💬 Descubra os talentos do seu filho de forma divertida<br>🌐 Tudo o que você precisa é de um computador e conexão com a internet<br>💙 Confiado por mais de 100.000 pais",
    image: {
      url: "/welcome/longquiz_br_dev_desktop.webp",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/longquiz_br_dev_mob.webp",
      style: {
        width: "100%",
      },
    },
    button: " Vamos lá! 🔥 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Obrigado por confiar em nossa plataforma educacional!",
    subtitle:
      "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question: "Qual é o gênero do seu filho?",
      answers: ["Masculino🧒", "Feminino👧", "Prefiro não dizer🤐"],
    },
    2: {
      title: "Quantos anos tem o seu filho?",
      type: "age",
      button: "",
    },
    3: {
      question: "O que seu filho gosta de fazer no tempo livre?",
      answers: [
        "Praticar esportes ou brincar ao ar livre ⚽",
        "Ler livros ou quadrinhos 📚",
        "Assistir TV, YouTube ou jogar videogames 🎮",
        "Passar tempo com amigos ou familiares 👫",
        "Outro 🙂",
      ],
    },
    4: {
      question:
        "Na escola, quais atividades ou matérias seu filho(a) mais gosta?",
      answers: [
        "Experimentos de ciências ou desafios de matemática 🧪🔢",
        "Leitura ou escrita 📚✍️",
        "Arte, música ou teatro 🎨🎶🎭",
        "Educação física ou esportes 🏃‍♀️⚽🏋️‍♂️",
        "Tecnologia ou computadores 💻📱",
        "Outro 🙂",
      ],
    },
    5: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/brazil_graph.webp",
      subtitle:
        "Embora seja recomendado que as crianças não passem mais de 2 horas por dia em dispositivos, na América Latina frequentemente ultrapassam as 5 horas. É aconselhável alternar entretenimento com atividades produtivas, como aulas de 1 a 1,5 horas.<br><br>Nossos programas foram projetados com isso em mente.",
      button: "Muito bem",
    },
    6: {
      question: "Como seu filho se sente em relação ao aprendizado online?",
      answers: [
        "Eles adoram e acham envolvente 💻❤️",
        "Preferem o aprendizado presencial 🙂",
        "Eles têm dificuldade para manter o foco 😵‍💫",
        "Eles nunca tentaram aprender online ❓",
      ],
    },
    7: {
      question:
        "Seu filho gosta de construir ou projetar coisas (por exemplo, com Lego, arte, quebra-cabeças)?",
      answers: [
        "Sim, ele adora construir e projetar coisas 🧩🏗️",
        "Às vezes, mas ele prefere outras atividades 🤔",
        "Não, ele não tem muito interesse nisso 🙅‍♂️",
      ],
    },
    8: {
      question: "Como seu filho aprende ou lembra melhor das coisas novas?",
      answers: [
        "Vendo (aprende de forma visual) 👁️",
        "Fazendo (aprende praticando) 👐",
        "Ouvindo (aprende auditivamente) 🎧",
        "Através de repetição e prática 🔄✏️",
        "Não sei ainda 🤔"
      ],
    },
    9: {
      question: "Quais atividades atraem seu filho?",
      answers: [
        "Esportes ou dança ⚽💃",
        "Artes criativas 🎨🖌️",
        "Atividades intelectuais 🧩♟️💻",
        "Jogos ou vídeos 🎮📺",
        "Outro 🙂",
      ],
    },
    10: {
      question: "Seu filho tem acesso a um laptop ou computador para estudar?",
      answers: [
        "Sim, ele tem o próprio dispositivo 💻✅",
        "Sim, mas ele compartilha com outras pessoas 🖥️👫",
        {
          answer: "Não, ele não tem acesso regular 🚫",
          stopAnswer: true,
        },
      ],
    },
    11: {
      question:
        "Por quanto tempo seu filho(a) costuma se concentrar em uma atividade?",
      answers: [
        "15 minutos 🕞",
        "30 minutos 🕘",
        "1 hora 🕐",
        "Mais de 1 hora 🕒",
      ],
    },
    12: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/br_team.png",
      title: "Aulas conduzidas por especialistas em tecnologia e educação",
      button: "Parece ótimo",
    },
    13: {
      question: "Como seu filho trabalha em grupo?",
      answers: [
        "Gosta de colaborar 🤝💡",
        "Prefere liderar 🧑‍⚖️",
        "Trabalha de forma independente, mas contribui 👤✔️",
        "Fica tímido ou desconfortável 😳",
      ],
    },
    14: {
      question:
        "Qual papel seu filho costuma desempenhar em atividades de grupo?",
      answers: [
        "Ele gosta de liderar e organizar 🧑‍⚖️🗂️",
        "Ele gosta de contribuir com ideias e colaborar 🤝💡",
        "Prefere ouvir e seguir 👂🙂",
        "Tenta mediar ou resolver conflitos ⚖️🕊️",
        "Ele se sente tímido e fica no fundo 😳",
      ],
    },
    15: {
      question:
        "Quão motivada(o) está sua criança para experimentar coisas novas?",
      answers: [
        "Muito motivada(o) ✨💪",
        "Precisa de incentivo 🤔👍",
        "Pouco motivada(o) 😕",
      ],
    },
    16: {
      question: "Como seu filho lida com desafios ou problemas?",
      answers: [
        "Ele tenta resolver sozinho 💪🧠",
        "Pede ajuda quando necessário 🙋‍♀️✔️",
        "Fica frustrado e desiste facilmente 😤",
        "Gosta de resolver problemas e vê isso como um desafio 🕵️‍♂️",
      ],
    },
    17: {
      question:
        "Como seu filho lida com tarefas que exigem atenção e pensamento lógico?",
      answers: [
        "Ele é bom em se concentrar e resolver problemas 🎯🧩",
        "Se sai bem com alguma orientação ou estrutura 🗂️🤝",
        "Dificuldade em focar em tarefas detalhadas 😵‍💫",
      ],
    },
    18: {
      question: "Quando seu filho conta uma história, ele tende a...",
      answers: [
        "Focar em muitos detalhes e descrições 📝📜",
        "Ir direto ao ponto principal 🎯",
        "Adicionar humor ou imaginação à história 🤪✨",
        "Lutar para organizar seus pensamentos 🤔",
      ],
    },
    19: {
      question: "Seu filho está confortável com tecnologia?",
      answers: [
        "Muito confortável, usa frequentemente 💻✔️",
        "Consegue tarefas básicas, mas precisa de orientação 🖱️❓",
        "Não está familiarizado 🚫",
      ],
    },
    20: {
      question:
        "Seu filho prefere seguir instruções ou criar suas próprias ideias?",
      answers: [
        "Ele adora instruções claras e completar tarefas 📋✔️",
        "Prefere ideias criativas e novas abordagens 🎨💡",
        "Fica nervoso e precisa de incentivo 😬🤗",
        "Gosta de uma mistura de estrutura e liberdade ⚖️🛠️",
        "Depende da tarefa – estrutura ou criatividade 🤷‍♂️",
      ],
    },
    21: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle:
        "Oferecemos formatos de aprendizado tanto individuais quanto em grupo, adaptando cuidadosamente o processo para atender à idade e às necessidades de cada criança.",
      button: "Vamos lá!",
    },
    22: {
      question: "Como seu filho normalmente reage ao tentar algo novo?",
      answers: [
        "Ele mergulha de cabeça com entusiasmo 🎉🚀",
        "Fica curioso, mas cauteloso 🤔👣",
        "Fica nervoso e precisa de incentivo 😬🤗",
        "Adora experimentar por conta própria 🛠️🔬",
        "Resiste a tentar coisas novas 🙅‍♂️",
      ],
    },
    23: {
      question: "Seu filho(a) é mais introvertido ou extrovertido?",
      answers: ["Introvertido 🤫", "Extrovertido 😄", "Não sei 🤷‍♂️"],
    },
    24: {
      question: "Seu filho(a) prefere atividades mais calmas ou mais ativas?",
      answers: ["Calmas 🧘‍♀️", "Ativas 🏃‍♂️", "Um pouco de cada ⚖️"],
    },
    25: {
      question: "Como seu filho(a) costuma resolver problemas?",
      answers: [
        "Tenta sozinho primeiro 🧠",
        "Pede ajuda 🙋‍♀️",
        "Procura soluções criativas 🎨💡",
      ],
    },
    26: {
      question: "Como seu filho(a) prefere expressar a criatividade?",
      answers: [
        "Desenhando ✏️🎨",
        "Contando histórias 📖🗣️",
        "Construindo coisas 🏗️",
        "Música 🎵🥁",
        "Outro ❓",
      ],
    },
    27: {
      question:
        "Seu filho gosta de criar coisas ou fazer atividades com amigos?",
      answers: [
        "Sim, adora projetos criativos em grupo 👫🎨",
        "Às vezes, depende da atividade 🤔",
        "Não, prefere tarefas individuais 👤💡",
      ],
    },
    28: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/brazil_fwd.webp",
      subtitle:
        "Na Kodland, os alunos projetam modelos 3D, criam quadrinhos, constroem jogos e desenvolvem programas de computador. Atualmente, 30.000 crianças em todo o mundo estão aprendendo conosco!",
      button: "Ótimo!",
    },
    //duplicate key '16' - changed to '29'
    29: {
      question:
        "Seu filho(a) tem interesse em criar suas próprias histórias ou personagens?",
      answers: [
        "Adora inventar histórias e personagens originais 📖",
        "Gosta de desenhar e dar vida às suas ideias 🎨",
        "Prefere assistir/ler histórias prontas em vez de criar 👀",
        "Ainda não demonstrou interesse, mas pode se animar 🤔",
      ],
    },
    30: {
      question:
        "Como seu filho(a) costuma lidar com desafios ou problemas?",
      answers: [
        "Ele tenta resolver os problemas sozinho 💪🧠",
        "Ele pede ajuda quando precisa 🙋‍♀️✔️",
        "Ele se frustra e desiste facilmente 😤",
        "Ele gosta de resolver problemas e encara como um desafio 🕵️‍♂️",
      ],
    },
    31: {
      question:
        "Sua criança gosta de compartilhar suas criações com outras pessoas (amigos, família)?",
      answers: [
        "Sim, sempre 😃🤝",
        "Às vezes 🤔",
        "Não, prefere manter em privado 🙊💌",
      ],
    },
    32: {
      question:
        "Sobre o que seu filho gosta de falar em suas histórias ou tópicos?",
      answers: [
        "Aventuras, mistérios ou fantasia 🗺️🐉",
        "Ciência, tecnologia ou invenções 🔬💻",
        "Histórias engraçadas ou bobas 🤪😂",
        "Eventos reais ou história 📜🌍",
        "Histórias sobre amizades ou emoções ❤️👫",
      ],
    },
    33: {
      question: "O que faz seu filho se sentir orgulhoso ou realizado?",
      answers: [
        "Completar uma tarefa desafiadora 🏆🧠",
        "Ajudar os outros ou contribuir 🤝❤️",
        "Aprender algo novo 📚✨",
        "Receber feedback positivo 🥳👏",
        "Resolver um problema complicado 🔍🧩",
      ],
    },
    34: {
      question: "O que mais inspira seu filho(a)?",
      answers: ["Histórias 📚✨", "Jogos 🎮", "Amigos 👫💛", "Desafios 🏆💡"],
    },
    35: {
      question: "Como seu filho(a) costuma passar o tempo com os amigos?",
      answers: [
        "Brincando ao ar livre 🌳🏃‍♂️",
        "Conversando 🗣️💬",
        "Jogando 🎲🎮",
        "Criando coisas juntos ✏️🏗️",
      ],
    },
    36: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/brazil_review.webp",
      subtitle:
        "Somos recomendados por pais de todo o mundo. Esperamos que em breve você se junte a eles 💙",
      button: "Estamos quase lá",
    },
    37: {
      question: "O que você mais espera das aulas de tecnologia e programação para seu filho(a)?",
      answers: [
        "Diversão 🎉😄",
        "Disciplina 📏✅",
        "Criatividade 🎨💡",
        "Habilidades para o futuro 🚀🖥️",
        "Socialização 👫💬",
      ],
    },
    38: {
      question:
        "Quão importante é para você ver o progresso do seu filho(a) de forma visual?",
      answers: ["Muito importante 👀📊", "Neutro 🤔", "Nada importante 🚫"],
    },
    39: {
      question: "O que motiva seu filho a manter o foco em uma tarefa?",
      answers: [
        "Um objetivo claro ou recompensa no final 🎯🏅",
        "Empolgação ou paixão pela tarefa ✨❤️",
        "Trabalhar em grupo 🤝💬",
        "Feedback positivo ou incentivo durante o processo 👏😊",
        "Um senso de competição ou desafio 🥇🔥",
      ],
    },
    40: {
      question: "Que tipo de feedback mais motiva seu filho(a)?",
      answers: [
        "Elogios 🌟👏",
        "Recompensas 🎁🏆",
        "Conselhos construtivos 📝💡",
      ],
    },
    41: {
      question:
        "Como você costuma apoiar o aprendizado do seu filho(a) em casa?",
      answers: [
        "Ajudando nas tarefas 📚✏️",
        "Incentivando a independência 💪🏠",
        "Acompanhando o progresso 📈👀",
        "Outro ❓",
      ],
    },
    42: {
      question:
        "Você gostaria que seu filho(a) explorasse habilidades do futuro, como programação ou inteligência artificial?",
      answers: ["Sim 👍✨", "Talvez mais tarde ⏳🤔", "Não ❌"],
    },
    43: {
      typeInfo: "loaderScreen",
      sliderImages: [
        "/welcome/br_longquiz_dev_2_r1.png",
        "/welcome/br_longquiz_dev_2_r2.png",
        "/welcome/br_longquiz_dev_2_r3.png",
      ],
      sliderImagesMobile: [
        "/welcome/br_longquiz_dev_2_r1_mob.png",
        "/welcome/br_longquiz_dev_2_r2_mob.png",
        "/welcome/br_longquiz_dev_2_r3_mob.png",
      ],
      textLoader: "Criando o plano de aprendizagem personalizado do seu filho",
      titleLoader: 'Confiado por mais de <span style="color: rgba(89, 136, 255, 1)">3.000.000</span> de pais e alunos',
      subtitleLoader: "⭐ 4,8 / 5 — baseado em mais de 50.000 avaliações",
    },
    44: {
      title: "Agende uma aula gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Quase lá! 🔥",
    },
    45: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    46: {
      title: "Obrigado 🎉 Faltam apenas alguns passos para concluir o cadastro",
      typeInfo: "pc-laptop",
      subtitle:
        "Por favor, observe que você precisará de um PC ou laptop funcional para a aula e que deve acompanhar seu filho durante toda a aula. Lembre-se de que a aula é individual e personalizada.",
      button: "O que mais?",
    },
    47: {
      title: "Verifique seu e-mail e WhatsApp antes da aula experimental 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Enviaremos um lembrete 24 horas antes da aula e 2 horas antes da aula pediremos para você confirmar sua presença. É muito importante que mantenhamos contato para que a aula não seja cancelada.",
      button: "O que mais?",
    },
    48: {
      title: "A aula vai acontecer na nossa plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
      button: "Entendi ✅",
    },
  },
};
